var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablerSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 14L21.5001 3M10.5001 14L14.0001 21C14.0439 21.0957 14.1144 21.1769 14.203 21.2338C14.2917 21.2906 14.3948 21.3209 14.5001 21.3209C14.6054 21.3209 14.7085 21.2906 14.7971 21.2338C14.8858 21.1769 14.9562 21.0957 15.0001 21L21.5001 3M10.5001 14L3.50007 10.5C3.40433 10.4561 3.3232 10.3857 3.26632 10.2971C3.20944 10.2084 3.1792 10.1053 3.1792 10C3.1792 9.89468 3.20944 9.79158 3.26632 9.70295C3.3232 9.61431 3.40433 9.54387 3.50007 9.5L21.5001 3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerSend);
export default __webpack_public_path__ + "static/media/tabler_send.33d5e3f51a5a6519c079aa784534416c.svg";
export { ForwardRef as ReactComponent };